// extracted by mini-css-extract-plugin
export var layout = "style_layout__k+lxR";
export var main = "style_main__ScI9V";
export var navMenuScrollOuter = "style_navMenuScrollOuter__roo7Z";
export var navMenuScrollInner = "style_navMenuScrollInner__Svzf3";
export var navMenuContainer = "style_navMenuContainer__NsOJK";
export var rotate = "style_rotate__lxAF4";
export var dotty = "style_dotty__jMDJh";